function formatTime(sec) {
  const s = Math.max(0, Math.floor(sec || 0));
  const m = Math.floor(s / 60);
  return String(m).padStart(2, "0") + ":" + String(s % 60).padStart(2, "0");
}

export default function AudioCuePlayerBar({
  playing,
  currentTime,
  duration,
  muted,
  color,
  onPlayPause,
  onSeek,
  onToggleMute,
}) {
  const progress = duration > 0 ? Math.min(1, Math.max(0, currentTime / duration)) : 0;
  const accent = color || "#1f2d6b";

  const seekFromEvent = (e) => {
    if (!onSeek || !(duration > 0)) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
    onSeek(ratio * duration);
  };

  return (
    <div className="audioCuePlayerWrap">
      <div className="audioCuePlayer" style={{ color: accent }}>
        <button
          type="button"
          className="acpBtn"
          onClick={(e) => {
            e.stopPropagation();
            onPlayPause && onPlayPause();
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
            <circle cx="12" cy="12" r="10.8" />
            {playing ? (
              <>
                <rect
                  x="8.6"
                  y="7.4"
                  width="2.3"
                  height="9.2"
                  rx="1.1"
                  fill="currentColor"
                  stroke="none"
                />
                <rect
                  x="13.1"
                  y="7.4"
                  width="2.3"
                  height="9.2"
                  rx="1.1"
                  fill="currentColor"
                  stroke="none"
                />
              </>
            ) : (
              <path d="M9.8 7.6 L16.4 12 L9.8 16.4 Z" fill="currentColor" stroke="none" />
            )}
          </svg>
        </button>
        <span className="acpTime">
          {formatTime(currentTime)}/{formatTime(duration)}
        </span>
        <div
          className="acpTrack"
          onClick={(e) => {
            e.stopPropagation();
            seekFromEvent(e);
          }}
        >
          <div className="acpTrackBg" />
          <div
            className="acpTrackFill"
            style={{ width: progress * 100 + "%", backgroundColor: accent }}
          />
          <div
            className="acpThumb"
            style={{ left: progress * 100 + "%", backgroundColor: accent }}
          />
        </div>
        <button
          type="button"
          className="acpBtn"
          onClick={(e) => {
            e.stopPropagation();
            onToggleMute && onToggleMute();
          }}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10.8" />
            <path d="M6.6 10.2 H8.8 L11.6 7.8 V16.2 L8.8 13.8 H6.6 Z" />
            {muted ? (
              <path d="M14.2 10 L17.6 14 M17.6 10 L14.2 14" />
            ) : (
              <>
                <path d="M14 10.2 Q15.2 12 14 13.8" />
                <path d="M16 8.6 Q18.4 12 16 15.4" />
              </>
            )}
          </svg>
        </button>
      </div>
    </div>
  );
}
